import React from "react";
import moment from "moment";
import "moment/locale/pt-br";
import ReactApexChart from "react-apexcharts";

const GraficoConsultasHistorico = ({ historical }) => {
  const meses = historical
    ?.map((item) =>
      moment(item.inquiryDate, "YYYY-MM").locale("pt-br").format("MMM/YYYY")
    )
    .reverse();

  const consultas = historical?.map((item) => item.occurrences).reverse();

  const options = {
    chart: {
      id: "grafico-consultas",
      toolbar: { show: false },
    },
    xaxis: {
      categories: meses,
      title: {
        text: "Mês",
      },
    },
    yaxis: {
      title: {
        text: "Consultas",
      },
    },
    dataLabels: {
      enabled: true,
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "45%",
      },
    },
    title: {
      text: "Histórico de Consultas por Mês",
      align: "left",
      style: {
        fontSize: "16px",
      },
    },
    colors: ["#3EED98"],
  };

  const series = [
    {
      name: "Consultas",
      data: consultas,
    },
  ];

  return (
    <div className="bg-white border rounded-lg p-4 shadow-sm mt-4">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default GraficoConsultasHistorico;
